"use client";

import { c as _c } from "react/compiler-runtime";
import Container from "@components/Container";
import LanguageLinks, { type Language } from "@components/SiteShell/LanguageLinks";
import { Icon } from "@justhome/react-ui";
import MobileMenu from "./MobileMenu";
import { useEffect, useState, type ReactNode } from "react";
const ChevronDown = t0 => {
  const $ = _c(5);
  const {
    open
  } = t0;
  const t1 = open ? "rotate(180deg)" : undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      transform: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon type="Down" size="16" fill="currentColor" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <span aria-hidden="true" className="inline-flex transition-transform duration-150" style={t2}>{t3}</span>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export interface ShellLink {
  label: string;
  href?: string;
}
export interface NavItem extends ShellLink {
  items?: ShellLink[];
  footer?: ShellLink;
}
export interface HeaderCta {
  label: string;
  href?: string;
  trackingId?: string;
}
const ShellAnchor = t0 => {
  const $ = _c(4);
  const {
    link,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== link.href || $[2] !== link.label) {
    t1 = link.href ? <a href={link.href} className={className}>{link.label}</a> : <span className={className}>{link.label}</span>;
    $[0] = className;
    $[1] = link.href;
    $[2] = link.label;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const NavMenu = t0 => {
  const $ = _c(20);
  const {
    item,
    open,
    onToggle
  } = t0;
  let t1;
  if ($[0] !== onToggle) {
    t1 = event => {
      event.stopPropagation();
      onToggle();
    };
    $[0] = onToggle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== open) {
    t2 = <ChevronDown open={open} />;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== item.label || $[5] !== open || $[6] !== t1 || $[7] !== t2) {
    t3 = <button type="button" aria-expanded={open} aria-haspopup="true" onClick={t1} className="inline-flex items-center gap-2xs px-3xs py-2xs rounded-s hover:text-primary-800 transition-colors focusable">{item.label}{t2}</button>;
    $[4] = item.label;
    $[5] = open;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = !open;
  let t5;
  if ($[9] !== item.items) {
    t5 = item.items?.map(_temp);
    $[9] = item.items;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== item.footer) {
    t6 = item.footer && <div className="border-t border-neutral-50 mt-2xs pt-2xs"><ShellAnchor link={{
        ...item.footer,
        label: `${item.footer.label} →`
      }} className="block px-3xs py-3xs rounded-s text-body-2 font-semibold text-primary-800 no-underline hover:bg-neutral-12" /></div>;
    $[11] = item.footer;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div hidden={t4} className="absolute left-none top-[calc(100%+8px)] min-w-[280px] bg-neutral-0 border border-neutral-50 rounded-3xs shadow-3 p-2xs z-30">{t5}{t6}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t7) {
    t8 = <div className="relative">{t3}{t7}</div>;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
const UtilityNav = t0 => {
  const $ = _c(12);
  const {
    cta,
    language,
    alternateLanguageHref,
    copy
  } = t0;
  let t1;
  if ($[0] !== copy.login || $[1] !== copy.loginHref) {
    t1 = <a href={copy.loginHref} className="hidden ml:inline-flex text-body-2 font-semibold text-neutral-675 px-3xs py-2xs rounded-s no-underline hover:text-primary-800 hover:bg-neutral-12 transition-colors focusable">{copy.login}</a>;
    $[0] = copy.login;
    $[1] = copy.loginHref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== cta) {
    t2 = cta && <a href={cta.href ?? "#"} data-tracking-event={cta.trackingId || undefined} className="inline-flex items-center justify-center h-2m px-2xs ml:px-3s rounded-s bg-primary-800 hover:bg-primary-825 text-neutral-0 text-button-2 font-semibold no-underline whitespace-nowrap overflow-hidden text-ellipsis min-w-none transition-colors focusable">{cta.label}</a>;
    $[3] = cta;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== alternateLanguageHref || $[6] !== language) {
    t3 = <span className="hidden ml:block"><LanguageLinks language={language} alternateLanguageHref={alternateLanguageHref} /></span>;
    $[5] = alternateLanguageHref;
    $[6] = language;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className="ml-auto flex items-center gap-2xs ml:gap-xs min-w-none">{t1}{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};

/** Strings only: this component crosses into the client from a server component. */
export interface SiteHeaderCopy {
  menu: string;
  close: string;
  login: string;
  loginHref: string;
  phone: string;
}
export interface SiteHeaderProps {
  nav: NavItem[];
  logo: string;
  mark: string;
  copy: SiteHeaderCopy;
  cta?: HeaderCta;
  language: Language;
  pathname: string;
  alternateLanguageHref: string | null;
  /**
   * Replaces the logo. The cobranded pair a partner page needs is built from NavBarLogo,
   * which reads `next/router` and so cannot be imported here — this component renders in
   * both routers.
   */
  logoSlot?: ReactNode;
  progress?: ReactNode;
  ground?: "white" | "tinted";
}
const RESTING_GROUNDS = {
  white: "bg-neutral-0",
  tinted: "bg-neutral-12"
};
const SiteHeader = t0 => {
  const $ = _c(39);
  const {
    nav,
    logo,
    mark,
    copy,
    cta,
    language,
    pathname,
    alternateLanguageHref,
    logoSlot,
    progress,
    ground: t1
  } = t0;
  const ground = t1 === undefined ? "white" : t1;
  const [open, setOpen] = useState(-1);
  const [stuck, setStuck] = useState(false);
  let t2;
  let t3;
  if ($[0] !== open) {
    t2 = () => {
      if (open === -1) {
        return;
      }
      const close = () => setOpen(-1);
      const onKeyDown = event => {
        if (event.key === "Escape") {
          close();
        }
      };
      document.addEventListener("click", close);
      document.addEventListener("keydown", onKeyDown);
      return () => {
        document.removeEventListener("click", close);
        document.removeEventListener("keydown", onKeyDown);
      };
    };
    t3 = [open];
    $[0] = open;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const sentinel = document.querySelector("[data-header-sentinel]");
      if (!sentinel || !("IntersectionObserver" in window)) {
        return;
      }
      const observer = new IntersectionObserver(t6 => {
        const [entry] = t6;
        return setStuck(!entry?.isIntersecting);
      });
      observer.observe(sentinel);
      return () => observer.disconnect();
    };
    t5 = [];
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div data-header-sentinel={true} aria-hidden="true" className="h-none" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `sticky top-none z-20 h-xl transition-[background-color,box-shadow] duration-150 ease-out ${stuck ? "bg-neutral-0 shadow-4" : RESTING_GROUNDS[ground]}`;
  let t8;
  if ($[6] !== language || $[7] !== logo || $[8] !== logoSlot || $[9] !== mark) {
    t8 = logoSlot ?? <a href={language === "de" ? "/" : `/${language}`} className="block flex-none focusable"><img src={mark} alt="Justhome" className="h-3s w-auto block ml:hidden" /><img src={logo} alt="" aria-hidden="true" className="h-m w-auto hidden ml:block" /></a>;
    $[6] = language;
    $[7] = logo;
    $[8] = logoSlot;
    $[9] = mark;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== nav || $[12] !== open) {
    let t10;
    if ($[14] !== open) {
      t10 = (item, index) => item.items ? <NavMenu key={`${item.label}-${index}`} item={item} open={open === index} onToggle={() => setOpen(open === index ? -1 : index)} /> : <ShellAnchor key={`${item.label}-${index}`} link={item} className="px-3xs py-2xs rounded-s no-underline text-neutral-425 hover:text-primary-800 transition-colors focusable" />;
      $[14] = open;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    t9 = nav.map(t10);
    $[11] = nav;
    $[12] = open;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <nav className="hidden ml:flex items-center gap-2xs text-body-2 font-book text-neutral-425">{t9}</nav>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== alternateLanguageHref || $[19] !== copy || $[20] !== cta || $[21] !== language) {
    t11 = <UtilityNav cta={cta} language={language} alternateLanguageHref={alternateLanguageHref} copy={copy} />;
    $[18] = alternateLanguageHref;
    $[19] = copy;
    $[20] = cta;
    $[21] = language;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== alternateLanguageHref || $[24] !== copy || $[25] !== language || $[26] !== mark || $[27] !== nav || $[28] !== pathname) {
    t12 = <MobileMenu nav={nav} mark={mark} language={language} pathname={pathname} alternateLanguageHref={alternateLanguageHref} copy={copy} />;
    $[23] = alternateLanguageHref;
    $[24] = copy;
    $[25] = language;
    $[26] = mark;
    $[27] = nav;
    $[28] = pathname;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t8) {
    t13 = <Container padding={true} className="h-full flex items-center gap-2xs ml:gap-m">{t8}{t10}{t11}{t12}</Container>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t8;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== progress || $[36] !== t13 || $[37] !== t7) {
    t14 = <>{t6}<header className={t7}>{t13}{progress}</header></>;
    $[35] = progress;
    $[36] = t13;
    $[37] = t7;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
};
export default SiteHeader;
function _temp(entry, index) {
  return <ShellAnchor key={`${entry.label}-${index}`} link={entry} className="block px-3xs py-3xs rounded-s text-body-2 font-book text-neutral-425 no-underline hover:bg-neutral-12 hover:text-primary-800" />;
}